import { useState, useEffect } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import React from 'react'
import { Schema, Form, InputPicker } from 'rsuite';
import RedStar from '../../../../Shared/GenericComponents/RedStar';
import { getBoardMembers } from '../../../../../services/Shared/codeTable.service';
import boardApprovalService from '../../../../../services/Internal/Application/PLS/boardApproval.service';
import BlockUi from '@availity/block-ui';

function BoardApprovalModal(props) {
    const { ObjectType, DateType } = Schema.Types;
    const [blockUi, setBlockUi] = useState(false);
    const model = Schema.Model({
        dateSent: DateType().isRequired('This field is required.'),
        boardMember: ObjectType().isRequired('This field is required.'),
    })
    const [boardMemebers, setBoardMembers] = useState([])
    const [approvalModel, setApprovalModel] = useState()
    useEffect(() => {
        setApprovalModel(props.modalData);
        getBoardMembers().then((result) => {
            var members = result;
            if (props.approvals) {
                props.approvals.forEach((ele) => {
                    members = members.filter(function (obj) {
                        return obj.value.id !== ele.boardMember.id;
                    });
                })
            }
            setBoardMembers(members);
        });
    }, [props.modalData])

    const formSubmit = (validation, event) => {
        if (validation) {
            setBlockUi(true);
            var formData = new FormData()
            var dataToTransmit = {
                ...approvalModel,
                dateSent: new Date(approvalModel.dateSent).toISOString(),
                dateReceived: approvalModel.dateReceived ? new Date(approvalModel.dateReceived).toISOString() : null
            }
            formDataAppender('boardMemberResponse', dataToTransmit, formData);
            for (var i = 0; i < approvalModel.files.length; i++) {
                formData.append('files', approvalModel.files[i].blobFile);
            }
            boardApprovalService.postBoardResponse(formData).then((response) => {
                setBlockUi(false);
                if (response.data.boardMemberResponse.id) {
                    props.updateGrid();
                    props.onHide();
                }

            })
        }

    }
    const formDataAppender = (passedKey, model, formData) => {
        for (let key in model) {
            if (typeof (model[key]) === 'object') {
                formDataAppender(`${passedKey}.${key}`, model[key], formData); // Recursive key for objects
            }
            else {
                if (passedKey)
                    formData.append(`${passedKey}.${key}`, model[key]);
                else
                    formData.append(`${key}`, model[key]);
            }
        }
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <BlockUi blocking={blockUi}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Board/Staff Member Selection
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form model={model} id="boardForm" formValue={approvalModel} onChange={approvalModel => setApprovalModel(approvalModel)} onSubmit={formSubmit} fluid>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Col>
                                    <Form.ControlLabel>
                                        <strong>
                                            Date Sent&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control type="date" name="dateSent" block />
                                </Col>
                                <Col>
                                    <Form.ControlLabel>
                                        <strong>
                                            Board/Staff Member&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control
                                        block
                                        name="boardMember"
                                        placeholder="Pick Board Member"
                                        accepter={InputPicker}
                                        data={boardMemebers} />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" form="boardForm" variant="primary">Submit</Button>
                    <Button variant="danger" onClick={props.onHide}>Cancel</Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
    );
}

export default BoardApprovalModal;